'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(Currency2) {
  Currency2["EUR"] = "EUR";
  Currency2["USD"] = "USD";
  Currency2["GBP"] = "GBP";
  Currency2["DKK"] = "DKK";
  Currency2["NOK"] = "NOK";
  Currency2["SEK"] = "SEK";
  Currency2["CAD"] = "CAD";
  Currency2["AUD"] = "AUD";
  Currency2["NZD"] = "NZD";
  Currency2["TRY"] = "TRY";
  Currency2["PLN"] = "PLN";
  Currency2["CHF"] = "CHF";
  Currency2["RUB"] = "RUB";
  Currency2["JPY"] = "JPY";
  Currency2["UAH"] = "UAH";
  Currency2["BRL"] = "BRL";
  Currency2["INR"] = "INR";
  Currency2["THB"] = "THB";
  Currency2["KRW"] = "KRW";
  Currency2["PEN"] = "PEN";
  Currency2["CLP"] = "CLP";
  Currency2["MXN"] = "MXN";
  Currency2["HRK"] = "HRK";
  Currency2["ZAR"] = "ZAR";
  Currency2["HKD"] = "HKD";
  Currency2["NAD"] = "NAD";
  Currency2["MKD"] = "MKD";
  Currency2["HUF"] = "HUF";
  Currency2["RON"] = "RON";
  Currency2["ARS"] = "ARS";
})(exports.Currency || (exports.Currency = {}));
(function(MaritalStatus2) {
  MaritalStatus2["MARRIED"] = "Married";
  MaritalStatus2["UNMARRIED"] = "Unmarried";
  MaritalStatus2["WIDOW"] = "Widow";
  MaritalStatus2["CIVIL_UNION_PARTNER"] = "CivilUnionPartner";
  MaritalStatus2["DOMESTIC_PARTNER"] = "DomesticPartner";
})(exports.MaritalStatus || (exports.MaritalStatus = {}));
(function(AuthenticationMethod2) {
  AuthenticationMethod2["ONE_FACTOR"] = "ONE_FACTOR";
  AuthenticationMethod2["TWO_FACTOR_BY_SMS"] = "TWO_FACTOR_BY_SMS";
  AuthenticationMethod2["TWO_FACTOR_BY_EMAIL"] = "TWO_FACTOR_BY_EMAIL";
  AuthenticationMethod2["TWO_FACTOR_BY_KBA"] = "TWO_FACTOR_BY_KBA";
})(exports.AuthenticationMethod || (exports.AuthenticationMethod = {}));
(function(SignUpEndpoint2) {
  SignUpEndpoint2["SignUpV2"] = "users/signUpV2";
  SignUpEndpoint2["QuickSignUpV2"] = "users/quickSignUpV2";
  SignUpEndpoint2["SignUpV2SC"] = "users/signUpV2SC";
  SignUpEndpoint2["SignUpLOTBA"] = "users/signUpLOTBA";
  SignUpEndpoint2["SignUpONJN"] = "users/signUpONJN";
  SignUpEndpoint2["SignUpAGCO"] = "users/signUpAGCO";
  SignUpEndpoint2["SignUpUKGC"] = "users/signUpUKGC";
  SignUpEndpoint2["SignUpEMTA"] = "users/signupEMTA";
  SignUpEndpoint2["QuickSignUpEMTA"] = "users/quickSignUpEMTA";
})(exports.SignUpEndpoint || (exports.SignUpEndpoint = {}));
